import React, { useEffect, useState } from "react";
import { CirclePlus, MoreVertical, Edit, Trash2 } from "lucide-react";
import Swal from "sweetalert2";
import LeaveManagementList from "./LeaveManagementList";
import api from "../../api/axios";
import { duration } from "moment";

const AddNewLeaveManagement = () => {
  const [leavemanagements, setLeaveManagements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [employees, setEmployees] = useState([]);
  const [leaveType, setLeaveType] = useState([]);

  const [formData, setFormData] = useState({
    employee_id: "",
    leave_type_id: "",
    from_date: "",
    to_date: "",
    duration_unit: "",
    remarks: "",
    is_approved: true,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const fetchLeaveManagements = async () => {
    try {
      const res = await api.get("/hrms/leaves?type=daily");
      setLeaveManagements(res.data.data || []);
    } catch (error) {
      Swal.fire("Error", "Failed to fetch leavemanagements", "error");
    } finally {
      setDataLoading(false);
    }
  };

  const fetchEmployees = async () => {
    try {
      const res = await api.get("/hrms/employees");
      setEmployees(res.data.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchLeaveTypes = async () => {
    try {
      const res = await api.get("/hrms/leave-types");
      setLeaveType(res.data.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    fetchEmployees();
    fetchLeaveTypes();
    fetchLeaveManagements();
  }, []);

  const handleAddLeaveManagement = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await api.post("/hrms/leaves", formData);

      if (res.status === 200 || res.status === 201) {
        Swal.fire("Success", "Leave Management added successfully!", "success");
        await fetchLeaveManagements();
      }
    } catch (error) {
      Swal.fire("Error", "Failed to add leave management.", "error");
    } finally {
      setLoading(false);
    }

    setFormData({
      employee_id: "",
      leave_type_id: "",
      from_date: "",
      to_date: "",
      remarks: "",
    });
  };

  const handleRemove = (id) => {
    if (
      window.confirm("Are you sure you want to remove this leave management?")
    ) {
      setLeaveManagements((prev) => prev.filter((emp) => emp.id !== id));
    }
  };

  const formatTime = (time) => {
    if (!time) return "-";
    return new Date(`1970-01-01T${time}`).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row">
        <div className="col-12">
          <div className="add-new-emp-container">
            <div className="d-flex flex-column">
              <h5 className="fs-4 fw-semibold">Add New Leave Management</h5>
              <span className="fs-6 text-muted">
                Add a new leave management to this property.
              </span>
            </div>
            <form className="mt-4" onSubmit={handleAddLeaveManagement}>
              <div className="row row-gap-3">
                <div className="col-lg-3 col-md-6 col-12">
                  <label htmlFor="First Name" className="form-label fw-medium">
                    Select Employee
                  </label>
                  <select
                    name="employee_id"
                    className="form-control"
                    value={formData.employee_id}
                    onChange={handleChange}
                  >
                    <option value="">-- Select Employee --</option>
                    {employees.map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        {emp.first_name} {emp.last_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-3 col-md-6 col-12">
                  <label htmlFor="First Name" className="form-label fw-medium">
                    Select Leave Type
                  </label>
                  <select
                    name="leave_type_id"
                    className="form-control"
                    value={formData.leave_type_id}
                    onChange={handleChange}
                  >
                    <option value="">-- Select Leave Type --</option>
                    {leaveType.map((l) => (
                      <option key={l.id} value={l.id}>
                        {l.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-lg-3 col-md-6 col-12">
                  <label htmlFor="department" className="form-label fw-medium">
                    Duration
                  </label>
                  <select
                    name="duration_unit"
                    id="duration_unit"
                    className="form-select"
                    value={formData.duration_unit}
                    onChange={handleChange}
                    style={{ backgroundColor: "#f9f9fa" }}
                  >
                    <option value="" selected hidden>
                      Select Duration
                    </option>
                    <option value="full">Full</option>
                    <option value="half">Half</option>
                  </select>
                </div>

                <div className="col-lg-3 col-md-6 col-12">
                  <label htmlFor="shiftEnd" className="form-label fw-medium">
                    From Date
                  </label>
                  <input
                    type="date"
                    name="from_date"
                    id="from_date"
                    className="form-control"
                    value={formData.from_date}
                    onChange={handleChange}
                    style={{ backgroundColor: "#f9f9fa" }}
                  />
                </div>
                <div className="col-lg-3 col-md-6 col-12">
                  <label htmlFor="shiftEnd" className="form-label fw-medium">
                    To Date
                  </label>
                  <input
                    type="date"
                    name="to_date"
                    id="to_date"
                    className="form-control"
                    value={formData.to_date}
                    onChange={handleChange}
                    style={{ backgroundColor: "#f9f9fa" }}
                  />
                </div>
                <div className="col-lg-3 col-md-6 col-12">
                  <label htmlFor="shiftEnd" className="form-label fw-medium">
                    Remarks
                  </label>
                  <input
                    type="text"
                    name="remarks"
                    id="remarks"
                    className="form-control"
                    value={formData.remarks}
                    onChange={handleChange}
                    style={{ backgroundColor: "#f9f9fa" }}
                  />
                </div>
              </div>
              <button
                type="submit"
                className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span>Adding...</span>
                  </>
                ) : (
                  <>
                    <CirclePlus size={18} />
                    Add Leave Management
                  </>
                )}
              </button>
            </form>
          </div>
          <LeaveManagementList
            loading={dataLoading}
            leavemanagements={leavemanagements}
            onHandleRemove={handleRemove}
          />
        </div>
      </div>
    </div>
  );
};

export default AddNewLeaveManagement;
